// extracted by mini-css-extract-plugin
export default {"gifSection":"GifSection_gifSection__-Eot4"};